"use strict";

// import Vue from 'vue';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ChartDoughnutlabel from 'chartjs-plugin-doughnutlabel-rebourne';

Chart.register(ChartDataLabels);
Chart.register(ChartDoughnutlabel);
Chart.defaults.plugins.datalabels.color = '#fff'

function chartjsCustomPlugin () {}
chartjsCustomPlugin.install = function (Vue) {
    Vue.prototype.$chartjs = {
        createChart (_ctx, _data) {
            const _Chart = Chart;
            return new _Chart(_ctx, _data)
        },
        updateChart (instance, _data) {
            instance.data = _data
            instance.update()
        },
        destroy (instance) {
            if (instance) {
                instance.destroy()
            }
        }
    }
};

export default chartjsCustomPlugin

// export default Plugin;
